"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // export const EMPTY_PLAYER_SLOT = 'EMPTY_PLAYER_SLOT';
//Make this node-compatible:
// Object.defineProperty(exports, "__esModule", {
//   value: true
// });
// var EMPTY_PLAYER_SLOT = exports.EMPTY_PLAYER_SLOT = 'EMPTY_PLAYER_SLOT';

var EMPTY_PLAYER_SLOT = exports.EMPTY_PLAYER_SLOT = "EMPTY_PLAYER_SLOT";